/**
 * @generated SignedSource<<0b3837d707aafd2a7f012f61b4f1ee49>>
 * @relayHash f4d93a10161f753ed411c57f86bc98b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type gqlGetComponentScorecardsQuery$variables = {
  componentId: string;
};
export type gqlGetComponentScorecardsQuery$data = {
  readonly compass: {
    readonly component: {
      readonly __typename: "CompassComponent";
      readonly name: string;
      readonly scorecards: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly scorecardScore: {
          readonly maxTotalScore: number;
          readonly totalScore: number;
        } | null | undefined;
      }> | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type gqlGetComponentScorecardsQuery = {
  response: gqlGetComponentScorecardsQuery$data;
  variables: gqlGetComponentScorecardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "componentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "concreteType": "CompassScorecard",
      "kind": "LinkedField",
      "name": "scorecards",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/),
        {
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "componentId",
                  "variableName": "componentId"
                }
              ],
              "kind": "ObjectValue",
              "name": "query"
            }
          ],
          "concreteType": "CompassScorecardScore",
          "kind": "LinkedField",
          "name": "scorecardScore",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalScore"
            },
            {
              "kind": "ScalarField",
              "name": "maxTotalScore"
            }
          ]
        }
      ]
    }
  ],
  "type": "CompassComponent"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "gqlGetComponentScorecardsQuery",
    "selections": [
      {
        "concreteType": "CompassCatalogQueryApi",
        "kind": "LinkedField",
        "name": "compass",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gqlGetComponentScorecardsQuery",
    "selections": [
      {
        "concreteType": "CompassCatalogQueryApi",
        "kind": "LinkedField",
        "name": "compass",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9",
    "metadata": {},
    "name": "gqlGetComponentScorecardsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bc264e75c2067aab1548341100b3d8c5";

export default node;
